export default __webpack_public_path__ + "static/balance-dac2dcf9574621700be220484269619e.jpg";